// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fhFt6N5dNLK8MS {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  width: calc(100% - 72px);
  margin: 0 auto;
}
.fhFt6N5dNLK8MS::before {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: var(--ds-border, #091e4224);
  border-radius: 1px;
}
.fhFt6N5dNLK8MS:focus {
  outline: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCardFront": `fhFt6N5dNLK8MS`
};
export default ___CSS_LOADER_EXPORT___;
